"use strict";

exports.__esModule = true;
exports.fetchAuctionList = exports.convertApiResult = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _graphqlRequest = _interopRequireWildcard(require("graphql-request"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const DEFAULT_PAGE_SIZE = 20;

/* eslint-disable */
const convertApiResult = (data, wallet, configs) => {
  var _data$collateralAucti, _data$collateralAucti2, _data$collateralAucti3;
  const {
    stableToken
  } = wallet.getPresetTokens();
  const list = (data === null || data === void 0 ? void 0 : (_data$collateralAucti = data.collateralAuctions) === null || _data$collateralAucti === void 0 ? void 0 : (_data$collateralAucti2 = _data$collateralAucti.nodes) === null || _data$collateralAucti2 === void 0 ? void 0 : _data$collateralAucti2.map(item => {
    const collateral = wallet.getToken(item.collateral);
    const initAmount = _sdkCore.FixedPointNumber.fromInner(item.initAmount, collateral.decimals);
    const amount = _sdkCore.FixedPointNumber.fromInner(item.amount, collateral.decimals);
    const targetAmount = _sdkCore.FixedPointNumber.fromInner(item.target || '0', stableToken.decimals);
    return {
      id: item.id,
      status: item.status,
      collateral,
      initialAmount: initAmount,
      amount,
      target: {
        amount: targetAmount,
        token: stableToken
      },
      stage: targetAmount.isZero() ? 'NORMAL' : 'REVERSE',
      refundRecipient: item.refundRecipient,
      winner: item.winner,
      // set zero as default
      minimumBidAmount: targetAmount,
      bids: item.bids.nodes.map(item => {
        const amount = _sdkCore.FixedPointNumber.fromInner(item.amount, stableToken.decimals);
        const collateralAmount = _sdkCore.FixedPointNumber.fromInner(item.collateralAmount, collateral.decimals);
        return {
          type: item.type,
          bid: {
            token: stableToken,
            amount: amount
          },
          lotSize: {
            token: collateral,
            amount: collateralAmount
          },
          bidPrice: collateralAmount.div(amount),
          timestap: new Date(item.timestamp),
          bidder: item.bidder,
          tx: item.extrinsic,
          timestamp: item.timestamp
        };
      }),
      startBlock: item.startBlockAt,
      endBlock: item === null || item === void 0 ? void 0 : item.endBlockAt
    };
  })) || [];
  const totalPage = Math.ceil(Number(data === null || data === void 0 ? void 0 : (_data$collateralAucti3 = data.collateralAuctions) === null || _data$collateralAucti3 === void 0 ? void 0 : _data$collateralAucti3.totalCount) / (configs.pageSize || DEFAULT_PAGE_SIZE));
  return {
    current: configs.page,
    totalPage,
    list
  };
};
/* eslint-enable */
exports.convertApiResult = convertApiResult;
const fetchAuctionList = (endpoint, params) => {
  const page = (params === null || params === void 0 ? void 0 : params.page) || 1;
  const pageSize = (params === null || params === void 0 ? void 0 : params.pageSize) || DEFAULT_PAGE_SIZE;
  const offset = (page - 1) * pageSize;
  let filter = '';
  if (params !== null && params !== void 0 && params.filter) {
    const temp = {
      and: []
    };
    if (params.filter.account) {
      temp.and.push({
        bidder: {
          contains: [`'${params.filter.account}'`]
        }
      });
    }
    if (params.filter.status) {
      temp.and.push({
        status: {
          equalTo: params.filter.status
        }
      });
    }
    if (temp.and.length !== 0) {
      filter = 'filter:' + JSON.stringify(temp).replace(/"/g, '').replace(/'/g, '"');
    }
  }
  return (0, _graphqlRequest.default)(endpoint, (0, _graphqlRequest.gql)`
    query {
      collateralAuctions (offset: ${offset}, first:${pageSize}, ${filter}, orderBy: [CREATE_AT_DESC, ID_DESC]) {
        totalCount
        nodes {
          id
          collateral
          initAmount
          amount
          target
          status
          winner
          bids(orderBy:[TIMESTAMP_DESC, EVENT_INDEX_DESC]){
            nodes{
              amount
              bidder
              type
              timestamp
              collateralAmount
              extrinsic
            }
          }
          dexTake(orderBy:TIMESTAMP_DESC){
            nodes {
              amount
            }
          }
          dealt(orderBy:TIMESTAMP_DESC){
            nodes {
              winner
              paymentAmount
            }
          }
        }
      }
    }
  `);
};
exports.fetchAuctionList = fetchAuctionList;